import React, { useContext } from "react";
import moment from "moment";
import { InputLabel } from "@material-ui/core";

import { MatchContext } from "../../context";
import { SET_DATA } from "../../reduce/actionTypes";

const ForecastNotes = ({ month, creatingNew }): JSX.Element => {
  const { state, dispatch } = useContext(MatchContext);

  const handleNotesChange = (e) => {
    const value = e.target.value;
    dispatch({
      type: SET_DATA,
      payload: { forecastNotes: value },
    });
  };

  return (
    <div className="notes-container">
      <div
        className={
          new Date(moment(month).format("YYYY-MM")) <
            new Date(moment().format("YYYY-MM")) &&
          !creatingNew &&
          "disabled"
        }
      >
        <InputLabel className="notes-label" id="notes">
          Notes
        </InputLabel>
        <textarea
          name="notes"
          id="forecast-notes"
          value={state.forecastNotes}
          onChange={handleNotesChange}
        ></textarea>
      </div>
    </div>
  );
};

export default ForecastNotes;
